/**
 * Utility functions for handling asset URLs
 */

/**
 * Converts a relative asset path to a full URL with the assets endpoint prefix
 * @param relativePath - The relative path from the database
 * @returns Full URL to the asset, or undefined if no path provided
 */
export function getAssetUrl<TPath extends string | undefined>(
  relativePath: TPath,
): TPath extends string ? string : undefined {
  if (!relativePath) {
    return undefined as TPath extends string ? string : undefined;
  }

  if (relativePath.startsWith(`${window.location.origin}/assets/`)) {
    return relativePath.toString() as TPath extends string ? string : undefined;
  }

  // Remove leading slash if present to avoid double slashes
  const cleanPath = relativePath.startsWith("/") ? relativePath.slice(1) : relativePath;

  return `${window.location.origin}/assets/${cleanPath}` as TPath extends string ? string : undefined;
}
